/* @flow */

import React from 'react';
import Relay from 'react-relay';

import { ListGrid } from 'depop/components/list';

import isProductViewable from 'depop/utils/isProductViewable';
import ProductListItem from './ProductListItem';

class ProductList extends React.PureComponent {
  props: {
    products: Object,
    compact: boolean,
    from: ?string,
    listName: string,
  };

  render() {
    const { listName, products, compact = false, from } = this.props;

    const filteredProducts = products.filter(product =>
      isProductViewable(product),
    );

    return (
      <ListGrid compact={compact}>
        {filteredProducts.map((product, iterator) =>
          <ProductListItem
            from={from}
            product={product}
            listName={listName}
            productListIndex={iterator}
            key={product.id}
          />,
        )}
      </ListGrid>
    );
  }
}

export default Relay.createContainer(ProductList, {
  fragments: {
    products: () => Relay.QL`
      fragment on Product @relay(plural: true) {
        ${ProductListItem.getFragment('product')}
        id
        publicId
        slug
        saleStatus
        description
        dateUpdated
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/components/ProductList/ProductList.js